import { Box } from '@material-ui/core';
import 'cropperjs/dist/cropper.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import authService from './api/authService';
import LoginPage from './routes/LoginPage';
import Routes from './routes/Routes';
import LeftDrawer from './shared/components/LeftDrawer';
import TopBar from './shared/components/TopBar';


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showingDrawer: false
        }

        this.toggleDrawer = this.toggleDrawer.bind(this);
    }

    componentDidMount() {
        authService.hasLoggedUser();
    }

    toggleDrawer() {
        this.setState({
            showingDrawer: !this.state.showingDrawer
        });
    }

    render() {
        const { isAuthenticated } = this.props;

        if (isAuthenticated) {
            return (
                <Box style={{ flex: 1 }}>
                    <TopBar toggleDrawer={this.toggleDrawer} />
                    <LeftDrawer toggleDrawer={this.toggleDrawer} showDrawer={this.state.showingDrawer} />
                    <Routes />
                </Box>
            );
        } else {
            return (
                <Box style={{ flex: 1 }}>
                    <LoginPage />
                </Box>
            );
        }
    }
}

const mapStateToProps = store => ({
    isAuthenticated: store.authState.isAuthenticated,
    loggedUser: store.authState.loggedUser
});

export default connect(mapStateToProps)(App);
